import React from "react";
import { GuideShell } from "@/foundation/guide";
// Registrazione idempotente del Pack GI Presenze (side-effect import).
import { APP_KEY } from "@/foundation/guide/packs/presenze";

/**
 * Route `/guida` di GI Presenze.
 *
 * La pagina e' un thin-wrapper della Foundation: renderizza `GuideShell`
 * passando l'``appKey`` del Pack GI Presenze. Nessuna logica applicativa
 * aggiuntiva vive qui: e' tutto centralizzato nella Foundation.
 */
export default function HelpCenter() {
  return <GuideShell appKey={APP_KEY} aiEnabled={false} backTo="/" />;
}
